export const MEDALLIA_FERGHOME_FORM_ID = 52183;
